// constants
import { PanelActionTypes } from './constants';
import { Panel as PanelDataType } from 'src/types/panel';

export type PanelActionType = {
    type:
        | PanelActionTypes.API_RESPONSE_SUCCESS
        | PanelActionTypes.API_RESPONSE_ERROR
        | PanelActionTypes.GET_PANELS
        | PanelActionTypes.ADD_PANEL
        | PanelActionTypes.EDIT_PANEL
        | PanelActionTypes.GET_PANEL
        | PanelActionTypes.RESET
        | PanelActionTypes.RESET_SUCCESS
        | PanelActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const panelApiResponseSuccess = (
    actionType: string,
    data: PanelDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PanelActionType => ({
    type: PanelActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const panelApiResponseError = (
    actionType: string,
    data: PanelDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PanelActionType => ({
    type: PanelActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addPanel = (params: any): PanelActionType => ({
    type: PanelActionTypes.ADD_PANEL,
    payload: params,
});

export const editPanel = (params: any): PanelActionType => ({
    type: PanelActionTypes.EDIT_PANEL,
    payload: params,
});

export const getPanel = (params: any): PanelActionType => ({
    type: PanelActionTypes.GET_PANEL,
    payload: params,
});

export const getPanels = (params: any): PanelActionType => ({
    type: PanelActionTypes.GET_PANELS,
    payload: params,
});

export const resetPanel = (): PanelActionType => ({
    type: PanelActionTypes.RESET,
    payload: {},
});

export const resetPanelSuccess = (): PanelActionType => ({
    type: PanelActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetPanelError = (): PanelActionType => ({
    type: PanelActionTypes.RESET_ERROR,
    payload: {},
});
